import { render, staticRenderFns } from "./insumosEditar.vue?vue&type=template&id=b5f291aa&scoped=true&"
import script from "./insumosEditar.vue?vue&type=script&lang=js&"
export * from "./insumosEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f291aa",
  null
  
)

export default component.exports